import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import '../assets/css/libs.css'
import '../assets/css/style.css'
import { AppState } from '../store'

interface CalcReversalResultProps {
  isResponsive: boolean
}

function formatMonths(months: number, startAge: number) {
  const year = startAge + Math.floor(months / 12)
  const month = months % 12
  return { year: `${year}`, month: `${month}` }
}

export const CalcReversalResultComponent: React.FC<CalcReversalResultProps> = ({
  isResponsive,
}) => {
  const result = useSelector((state: AppState) => state.calcReversal.result)

  const formatMonthsStr = useMemo(() => {
    if (result) {
      return {
        deposit: result.depositMonths
          ? formatMonths(result.depositMonths, result.startAge)
          : { year: '120+', month: '- - - - -' },
        interest1: result.months1
          ? formatMonths(result.months1, result.startAge)
          : { year: '120+', month: '- - - - -' },
        interest2: result.months2
          ? formatMonths(result.months2, result.startAge)
          : { year: '120+', month: '- - - - -' },
      }
    } else {
      return {
        deposit: { year: '- - - - -', month: '- - - - -' },
        interest1: { year: '- - - - -', month: '- - - - -' },
        interest2: { year: '- - - - -', month: '- - - - -' },
      }
    }
  }, [result])

  return (
    <div className="c-grid--justify-content-between u-mt16px c-form--result">
      <div className="c-grid__col">
        <div className="c-form-group u-mr0">
          <span className="c-form-group__sup notit">運用しない場合の終了年齢</span>
          <span className="c-form-group__input u-md-mb20px">
            <input
              type="text"
              placeholder="- - - - -"
              className="c-form__output u-size--w110px"
              readOnly
              value={formatMonthsStr.deposit.year}
            />
            <span className="c-form-group__text--large">歳</span>
            <input
              type="text"
              placeholder="- - - - -"
              className="c-form__output u-size--w90px"
              readOnly
              value={formatMonthsStr.deposit.month}
            />
            <span className="c-form-group__text--large">ヶ月</span>
          </span>
        </div>
      </div>
      <div className="c-grid__col">
        <div className="c-form-group u-mr0">
          <span className="c-form-group__sup notit">パターン1で運用した場合の終了年齢</span>
          <span className="c-form-group__input u-md-mb20px">
            <input
              type="text"
              placeholder="- - - - -"
              className="c-form__output u-size--w110px"
              readOnly
              value={formatMonthsStr.interest1.year}
            />
            <span className="c-form-group__text--large">歳</span>
            <input
              type="text"
              placeholder="- - - - -"
              className="c-form__output u-size--w90px"
              readOnly
              value={formatMonthsStr.interest1.month}
            />
            <span className="c-form-group__text--large">ヶ月</span>
          </span>
        </div>
      </div>
      <div className="c-grid__col">
        <div className="c-form-group u-mr0">
          <span className="c-form-group__sup notit">パターン2で運用した場合の終了年齢</span>
          <span className="c-form-group__input">
            <input
              type="text"
              placeholder="- - - - -"
              className="c-form__output u-size--w110px"
              readOnly
              value={formatMonthsStr.interest2.year}
            />
            <span className="c-form-group__text--large">歳</span>
            <input
              type="text"
              placeholder="- - - - -"
              className="c-form__output u-size--w90px"
              readOnly
              value={formatMonthsStr.interest2.month}
            />
            <span className="c-form-group__text--large">ヶ月</span>
          </span>
        </div>
      </div>
    </div>
  )
}
